var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_vm._m(0),_c('div',{staticClass:"sub-bar"}),_c('div',{staticClass:"w-100"},[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar w-100 bg-white"},[_c('img',{attrs:{"src":require("@/assets/images/common/drip-logo.svg"),"width":"100","height":"34","alt":"company"}})])
}]

export { render, staticRenderFns }